//
//
// TODO really need to create action groups where these clusters like OTHER_USER_READ_ACTIONS become named
// groups in the AVP schema.

export type ActionName =
  | TrackingActionName
  | UsersActionName
  | GroupsActionName;

export type TrackingActionName =
  | "Tracking:GetTiles"
  | "Tracking:GetStatus"
  | "Tracking:GetData";

export type UsersActionName =
  // Always authenticated for principal (no one can make a friend request on my behalf)
  // Sometimes authenticated for resource (some users/groups allow everyone to make
  // follow/join requests, others don't)
  | "Users:CreateFollowRequest"
  // friend-facing user info
  | "Users:GetProfile"
  | "Users:GetFollowers"
  | "Users:GetFollows"
  | "Users:GetUserGroups"
  // Self only
  | "Users:GetSignInAttributes"
  | "Users:ManageFollows"
  | "Users:UpdateUser";

export type GroupsActionName =
  | "Groups:CreateJoinRequest"
  | "Groups:ManageGroup"
  | "Groups:GetGroupUsers";

export const OTHER_USER_READ_ACTIONS: UsersActionName[] = [
  "Users:GetProfile",
  "Users:GetFollowers",
  "Users:GetFollows",
  "Users:GetUserGroups",
];

export const OTHER_USER_TRACKING_READ_ACTIONS: TrackingActionName[] = [
  "Tracking:GetTiles",
  "Tracking:GetStatus",
  "Tracking:GetData",
];

export const GROUP_ADMIN_ACTIONS: GroupsActionName[] = ["Groups:ManageGroup"];

export const GROUP_DATA_ACCESS_ACTIONS: ActionName[] = [
  "Groups:CreateJoinRequest",
  "Groups:GetGroupUsers",
  "Tracking:GetData",
  "Tracking:GetTiles",
];

export const USER_DATA_ACCESS_ACTIONS: ActionName[] = [
  ...OTHER_USER_TRACKING_READ_ACTIONS,
  ...OTHER_USER_READ_ACTIONS,
  "Users:CreateFollowRequest",
];

export const USER_SELF_ADMINISTRATION_ACTIONS: ActionName[] = [
  ...USER_DATA_ACCESS_ACTIONS,
  "Users:GetSignInAttributes",
  "Users:ManageFollows",
  "Users:UpdateUser",
];

// This strange map is used to use types to enforce that we have every possible ActionName in this list.
const ALL_ACTION_NAMES_MAP: Record<ActionName, true> = {
  "Tracking:GetTiles": true,
  "Tracking:GetStatus": true,
  "Tracking:GetData": true,
  "Users:CreateFollowRequest": true,
  "Users:GetProfile": true,
  "Users:GetFollowers": true,
  "Users:GetFollows": true,
  "Users:GetUserGroups": true,
  "Users:GetSignInAttributes": true,
  "Users:ManageFollows": true,
  "Users:UpdateUser": true,
  "Groups:CreateJoinRequest": true,
  "Groups:ManageGroup": true,
  "Groups:GetGroupUsers": true,
};

export const ALL_ACTION_NAMES = Object.keys(
  ALL_ACTION_NAMES_MAP,
) as (keyof typeof ALL_ACTION_NAMES_MAP)[];
